import React from 'react';

export const Textarea = ({ value, onChange, label = '', height = '100px' }) => {
  return (
    <div className="form-floating">
      <textarea
        className={'form-control'}
        style={{ height: height }}
        id="floatingTextarea2"
        value={value}
        onChange={onChange}
      ></textarea>

      <label for="floatingTextarea2">{label}</label>
    </div>
  );
};
